import { useMemo } from 'react'
import IInstallationShop from '../../models/IInstallationShop'
import { isKitSku, getKitType, getAllowedPartForDifm3 } from '../../utility/allowedPartsForDifm3'
import { useDifm3Context } from '../contexts/difm3.context'

const useSuggestedShopForPart = (partName: string, sku: string, isSetFromVendor: boolean) => {
  const { difmState: { suggestedShops } } = useDifm3Context()

  return useMemo<IInstallationShop | null>(() => {
    const allowedPart = getAllowedPartForDifm3(partName)

    if (!suggestedShops || suggestedShops.isLoading || !suggestedShops.installationShop || !allowedPart) {
      return null
    }

    if (!suggestedShops.partPrices) {
      return null
    }

    const isKit = isKitSku(sku, isSetFromVendor)
    const kitType = getKitType(sku, isSetFromVendor)
    const formatPartName = (isKit ? `${allowedPart}-${kitType}` : allowedPart)?.toLowerCase()
    // eslint-disable-next-line security/detect-object-injection
    const priceDetails = suggestedShops.partPrices[formatPartName]

    return {
      ...suggestedShops.installationShop,
      ...priceDetails,
      isSelected: false,
    }
  }, [isSetFromVendor, partName, sku, suggestedShops])
}

export default useSuggestedShopForPart
